import "./style.css";
import Fundo from "../../assets/Fundo.png";
import { useState } from "react";
import React from "react";
import api from "../../services/api.js";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../context/AppContext.jsx";

function Login() {
  const navigate = useNavigate();
  const [usuario, setusuario] = useState("");
  const [senha, setsenha] = useState("");
  const [sucesso, setsucesso] = useState("");
  const [loading, setloading] = useState(false);
  const {
    setCodUsuario,
    updateLoginData,
    setUsuario,
    setCodEmpresa,
    setCodAssinante,
    setPerfil
  } = useAppContext();

  function ProcessaLogin(e) {
    e.preventDefault();
    setsucesso("");
    setloading(true);
    api
      .post("v1/login", {        
        usuario,
        senha,
      })
      .then((response) => {       
        const companiesData = response.data.empresas;      

        setCodAssinante(response.data.codassinante);
        if (companiesData.length === 1) {
          setCodEmpresa(response.data.empresas[0].codempresa);
        }
    
        updateLoginData(companiesData, response.data.token); 

        setCodUsuario(response.data.codusuario);
        setUsuario(response.data.usuario);
        setPerfil(response.data.perfil);

        setsucesso("S");
        navigate("/principal");
      })
      .catch(() => {
        setsucesso("N");
        setloading(false);
      });
  }

  return (
    <div className="container">     
      <div className="logina">
        <img className="background-login" src={Fundo} alt="Fundo" />
        <form className="form-login">
          <h3 className="mb-4">Autenticação</h3>

          <div className="form-floating">
            <input
              onChange={(e) => setusuario(e.target.value)}
              type="text"
              className="form-control"
              id="usuario"
              placeholder="Usuário"
            />
            <label htmlFor="usuario">Usuário</label>
          </div>

          <div className="form-floating">
            <input
              onChange={(e) => setsenha(e.target.value)}
              type="password"
              className="form-control"
              id="senha"
              placeholder="Senha"
            />
            <label htmlFor="senha">Senha</label>
          </div>

          <button
            onClick={ProcessaLogin}
            className="w-100 btn btn-lg btn-success"
            disabled={loading}
          >
            {loading ? (
              <div>
                <span
                  className="spinner-border spinner-border-sm text-light"
                  role="status"
                ></span>
                <span className="ms-2">Autenticando...</span>
              </div>
            ) : (
              <span className="ms-2">Acessar</span>
            )}
          </button>
          {sucesso === "N" ? (
            <div className="alert alert-danger mt-2" role="alert">
              Usuário ou senha inválidos
            </div>
          ) : null}          
        </form>
      </div>
    </div>
  );
}

export default Login;
